import { useEffect } from 'react';
import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import AddBlog from '../../../src/pages/AddBlog';
import Blog from '../../../src/pages/Blog';
import AddCareer from '../../pages/AddCareer';
import AddEvents from '../../pages/AddEvents';
import AddTallyAddons from '../../pages/AddTallyAddon';
import AddUsers from '../../pages/AddUsers';
import Career from '../../pages/Career';
import Dashboard from '../../pages/Dashboard';
import Events from '../../pages/Events';
import Login from '../../pages/Login';
import TallyAddons from '../../pages/TallyAddon';
import UsersList from '../../pages/UsersList';
import ViewComment from '../../pages/ViewComments';
import AddHashtags from '../../pages/AddHashtags'
import Swal from 'sweetalert2';
import AddExeFileUpload from '../../pages/AddExeFileUpload/index.js';
import EditBlog from '../../pages/Edit_Blog';
import EditRenewal from '../../pages/Edit_Renewal';
import EditCareer from '../../pages/EditCareer';
import EditDownload from '../../pages/EditDownload';
import Editevent from '../../pages/EditEvent';
import EditNewlicence from '../../pages/EditNewlicence';
import EditTallyAddon from '../../pages/EditTallyAddon.js';
import EdituserDetails from '../../pages/EdituserDetails';
import ExeUploadsList from '../../pages/ExeUploadsList/index.js';
import JobCandidate from '../../pages/JobCandidate';
import NewLicence from '../../pages/Pricing/NewLicence.js';
import RenewalLicense from '../../pages/Pricing/RenewalLicense.js';
import EventRegistration from '../../pages/EventRegistration/index.js';
import ConfirmationList from '../../pages/ConfirmationBy/ConfirmationList.js';
import Enquiries from '../../pages/Enquiries';
import EventWiseUserRegistration from '../../pages/EventWiseUserRegistration/index.js';

const ProtectedRoute = ({ isLoggedIn }) => {
  return isLoggedIn ? <Outlet /> : <Navigate to="/" />;
};

export default function NavigationRouting() {
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem("AdminUser_Name"));
  const userType = localStorage.getItem("AdminUser_Type"); 

  useEffect(() => {
    const handleBackNavigation = (event) => {
      if (!isLoggedIn) {
        event.preventDefault();
       localStorage.removeItem("isLoggedIn"); // Clear session
        Swal.fire({
          icon: 'error',
          title: 'Session Expired',
          text: 'Your session has expired. Please log in again.',
        }).then(() => {
          localStorage.removeItem("isLoggedIn"); 
          navigate('/'); 
          //  Redirect to login page
        });
      }
    };

    // Prevent back navigation after logout
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', handleBackNavigation);

    return () => {
      window.removeEventListener('popstate', handleBackNavigation);
    };
  }, [navigate, isLoggedIn]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />

      
      <Route element={<ProtectedRoute isLoggedIn={isLoggedIn} />}>

          <Route path="/blog-view" element={<Blog />} />
          <Route path="/add-blog" element={<AddBlog />} />
          <Route path="/edit-blog/:id" element={<EditBlog />} />
      

      {userType === "Admin" && (
          <>
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path="/events" element={<Events />} />
        <Route path="/add-events" element={<AddEvents />} />
        <Route path="/edit-event/:id" element={<Editevent />} />
        {/* <Route path="/event-registration" element={<EventRegistration/>} /> */}

        <Route path="/users-list" element={<UsersList />} />
        <Route path="/add-user" element={<AddUsers />} />   

        <Route path="/confirmation-list" element={<ConfirmationList/>} />    
        
        {/* <Route path="/blog-view" element={<Blog />} />
        <Route path="/add-blog" element={<AddBlog />} />
        <Route path="/edit-blog/:id" element={<EditBlog />} /> */}

        <Route path="/add-hashtags" element={<AddHashtags/>} />
                
        <Route path="/view-comment" element={<ViewComment />} />
        <Route path="/career" element={<Career />} />
        <Route path="/add-career" element={<AddCareer />} />
        <Route path="/tally-addons" element={<TallyAddons />} />
        <Route path="/add-tally-addons" element={<AddTallyAddons />} />
        <Route path="/exe-uploads" element={<ExeUploadsList/>} />
        <Route path="/add-exe-file-upload" element={<AddExeFileUpload/>} />
        <Route path="/JobCandidate" element={<JobCandidate />} />
        <Route path="/enquiries" element={<Enquiries />} />
        
        <Route path="/new-licence" element={<NewLicence/>} />.
        <Route path="/renewal-licence" element={<RenewalLicense/>} />        

        <Route path="/edit-user/:id" element={<EdituserDetails/>} />        
        <Route path="/edit-career/:id" element={<EditCareer />} />
        <Route path="/edit-tally-addon/:id" element={<EditTallyAddon />} />
        
        <Route path="/edit-download/:id" element={<EditDownload />} />        
        <Route path="/edit-new-licence/:id" element={< EditNewlicence/>} />
        <Route path="/edit-renewal/:id" element={< EditRenewal/>} />
        <Route path="/event-wise-user-registration-report" element={<EventWiseUserRegistration/>} />
          </>
        )}     

      </Route>
      <Route path="/event-registration" element={<EventRegistration/>} />
      {/* http://localhost:3000/event-registration
       */}
    </Routes>
  )
}
